import { render, staticRenderFns } from "./reports-issued-certificates.vue?vue&type=template&id=5dc504dd&scoped=true"
import script from "./reports-issued-certificates.vue?vue&type=script&lang=js"
export * from "./reports-issued-certificates.vue?vue&type=script&lang=js"
import style0 from "./reports-issued-certificates.vue?vue&type=style&index=0&id=5dc504dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc504dd",
  null
  
)

export default component.exports